// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event {
  position: absolute;
  background-color: white;
  color: black;
  bottom: 3%;
  left: 1.5%;
  width: 92.5%;
  padding: 10px;
  border-radius: 30px;
  border: black solid 3px;
  box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.5);
  font-size: 1rem;
}

.event-box {
  position: relative;
  z-index: 5;
  padding-bottom: 0.25em;
}

.event-dialogue {
  position: relative;
  z-index: 5;
  padding-bottom: 0.25em;
  font-size: 1rem;
}

.options-container {
  display: flex;
  flex-direction: column;
  height: -moz-fit-content;
  height: fit-content;
}

.option, .next {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: calc(-moz-fit-content + 20px);
  height: calc(fit-content + 20px);
  margin-top: 0.5em;
  padding-left: 1.25em;
  padding-right: 1.25em;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
  border-radius: 30px;
  border-style: solid;
}

.next {
  align-self: flex-end;
  justify-self: flex-end;
  justify-content: center;
  width: 5rem;
}

.option-null {
  background-color: grey;
}

.option-null:hover {
  cursor: not-allowed;
  box-shadow: none;
}

.event-contents-exit {
  opacity: 1;
}

.event-contents-exit-active {
  opacity: 1;
  transition: opacity 1000ms;
}

.event-contents-exit-done {
  opacity: 1;
  transition: opacity 1000ms;
}

.event-contents-enter {
  opacity: 0;
}

.event-contents-enter-active {
  opacity: 1;
  transition: opacity 1000ms;
}

.event-contents-enter-done {
  opacity: 1;
  transition: opacity 1000ms;
}

@media screen and (max-width: 450px) {
  .event {
    left: 0.6%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Event.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,eAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,qCAAA;EAAA,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,mBAAA;EACA,gBAAA;AADF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;EACA,0BAAA;AAHF;;AAMA;EACE,UAAA;EACA,0BAAA;AAHF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,UAAA;EACA,0BAAA;AALF;;AAQA;EACE,UAAA;EACA,0BAAA;AALF;;AAQA;EACE;IACE,UAAA;EALF;AACF","sourcesContent":["\n.event {\n  position: absolute;\n  background-color: white;\n  color: black;\n  bottom: 3%;\n  left: 1.5%;\n  width: 92.5%;\n  padding: 10px;\n  border-radius: 30px;\n  border: black solid 3px;\n  box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.5);\n  font-size: 1rem;\n}\n\n.event-box {\n  position: relative;\n  z-index: 5;\n  padding-bottom: .25em;\n}\n\n.event-dialogue {\n  position: relative;\n  z-index: 5;\n  padding-bottom: .25em;\n  font-size: 1rem;\n}\n\n\n.options-container {\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n}\n\n.option, .next {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: calc(fit-content + 20px);\n  margin-top: .5em;\n  padding-left: 1.25em;\n  padding-right: 1.25em;\n  padding-top: .2em;\n  padding-bottom: .2em;\n  border-radius: 30px;\n  border-style: solid;\n} \n\n.next {\n  align-self: flex-end;\n  justify-self: flex-end;\n  justify-content: center;\n  width: 5rem;\n}\n\n.option-null {\n  background-color: grey;\n}\n\n.option-null:hover {\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n// Fade out\n\n.event-contents-exit {\n  opacity: 1;\n}\n\n.event-contents-exit-active {\n  opacity: 1;\n  transition: opacity 1000ms;\n}\n\n.event-contents-exit-done {\n  opacity: 1;\n  transition: opacity 1000ms;\n}\n\n// Fade in\n\n.event-contents-enter {\n  opacity: 0;\n}\n\n.event-contents-enter-active {\n  opacity: 1;\n  transition: opacity 1000ms;\n}\n\n.event-contents-enter-done {\n  opacity: 1;\n  transition: opacity 1000ms;\n}\n\n@media screen and (max-width: 450px) {\n  .event {\n    left: .6%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
